const ar = {
  meta: {
    siteName: "Nieder-Eschbacher Pflegedienst GmbH",
    titleSuffix: "Nieder-Eschbacher Pflegedienst",
    description:
      "Nieder-Eschbacher Pflegedienst GmbH، خدمة رعاية منزلية في فرانكفورت أم ماين. رعاية منزلية حانية ومتخصصة: العناية الأساسية، الرعاية التمريضية الطبية، المساعدة المنزلية، وإمكانية التواصل على مدار الساعة.",
    pages: {
      home: "",
      about: "من نحن",
      services: "خدماتنا",
      news: "الأخبار وفرص العمل",
      contact: "اتصل بنا",
      imprint: "بيانات الناشر",
      privacy: "سياسة الخصوصية",
      notFound: "الصفحة غير موجودة",
    },
  },

  common: {
    call: "اتصال",
    callNow: "اتصل بنا الآن:",
    contactUs: "تواصل معنا",
    bookConsultation: "احجز استشارة",
    bookAppointment: "احجز موعداً",
    requestConsultation: "اطلب استشارة",
    aroundTheClock: "على مدار الساعة:",
    reachable24h: "متاحون على مدار الساعة",
    certifiedStaff: "طاقم تمريض معتمد",
    whatsapp: "واتساب",
    whatsappText: "مرحباً، لديّ سؤال حول خدمة الرعاية لديكم.",
    whatsappNote: "يرجى عدم إرسال بيانات صحية عبر واتساب. في الحالات الطارئة يرجى الاتصال بنا هاتفياً.",
    symbolImage: "صورة تعبيرية",
    language: "اللغة",
    changeLanguage: "اختر اللغة",
    skipToContent: "الانتقال إلى المحتوى",
    legalNote: "هذه الترجمة لغرض الاطلاع فقط. النسخة الألمانية هي الملزمة قانونياً.",
  },

  header: {
    topbar24h: "متاحون 24 ساعة",
    topbarConsult: "استشارة شخصية مجانية",
    mainNav: "القائمة الرئيسية",
    mobileNav: "قائمة الجوال",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
  },

  nav: {
    home: "الرئيسية",
    about: "من نحن",
    services: "خدماتنا",
    news: "الأخبار",
    contact: "اتصل بنا",
    jobs: "فرص العمل",
    imprint: "بيانات الناشر",
    privacy: "الخصوصية",
  },

  footer: {
    reach: "للتواصل معنا",
    fax: "فاكس:",
    emergency: "رقم الطوارئ على مدار الساعة:",
    navigation: "الصفحات",
    legal: "معلومات قانونية",
    area: "فرانكفورت أم ماين والمناطق المجاورة (بشكل خاص Nieder-Eschbach)",
    rights: "جميع الحقوق محفوظة.",
  },

  floating: {
    whatsappLabel: "راسلونا عبر واتساب",
    callLabel: "اتصل بنا الآن:",
    toTop: "العودة إلى الأعلى",
  },

  home: {
    eyebrow: "خدمة رعاية منزلية · فرانكفورت أم ماين",
    h1a: "رعاية حانية ومتخصصة",
    h1b: "في منزلكم",
    lead:
      "من أجل حياة هانئة، حتى عندما يفرض التقدّم في السن أو المرض الحاجة إلى الرعاية. نحن نمنحكم وقتنا.",
    heroImgAlt: "ممرّضة من Nieder-Eschbacher Pflegedienst تضع يديها على كتفي رجل مسنّ مبتسم، وبجانبهما الشعار والخدمات: الرعاية الأساسية، الرعاية التمريضية، المساعدة المنزلية، الرعاية الفردية",
    badgeTitle: "بقلب ووقت",
    badgeText: "رعاية لا تعرف العجلة",
    welcomeQuote:
      "نحن فريق Nieder-Eschbacher Pflegedienst في فرانكفورت أم ماين، ويسعدنا اهتمامكم. نعمل يوماً بعد يوم من أجل من يمنحوننا ثقتهم، ونقدّم رعاية عالية الجودة في خصوصية منزلكم. طاقمنا الودود يمنحكم وقته.",
    features: [
      {
        icon: "Clock",
        title: "نمنحكم وقتنا",
        text: "تعامل حانٍ بلا عجلة. نريد أن تشعروا معنا بالراحة.",
        to: "about",
        cta: "من نحن",
      },
      {
        icon: "HeartHandshake",
        title: "خدماتنا",
        text: "عناية أساسية ورعاية تمريضية طبية مصمّمة خصيصاً لكم.",
        to: "services",
        cta: "خدماتنا",
      },
      {
        icon: "Newspaper",
        title: "الأخبار وفرص العمل",
        text: "جديد خدمتنا والوظائف الشاغرة في مجال الرعاية.",
        to: "news",
        cta: "الأخبار",
      },
    ],
    servicesEyebrow: "خدماتنا",
    servicesTitle: "رعاية فردية تناسب احتياجاتكم تماماً",
    servicesLead:
      "من العناية الأساسية إلى التواصل على مدار الساعة: نرافقكم بشكل شامل في منزلكم الذي تألفونه.",
    valuesEyebrow: "قيمنا",
    valuesTitle: "الاحترام والعناية والتعامل المسؤول",
    valuesLead:
      "الاحترام والعناية والتعامل المسؤول هي مبادئنا الأساسية. نعامل كل إنسان كما نحب أن نُعامَل نحن.",
    ctaTitle: "لستم متأكدين من درجة الرعاية التي تستحقونها؟",
    ctaLead: "يسعدنا تقديم المشورة لكم شخصياً، في مكتبنا أو في منزلكم. مجاناً ودون أي التزام.",
  },

  values: [
    { icon: "Heart", label: "رعاية فردية" },
    { icon: "BadgeCheck", label: "طاقم تمريض معتمد" },
    { icon: "MessageCircle", label: "استشارة شخصية" },
    { icon: "ShieldCheck", label: "تعامل مسؤول" },
  ],

  services: [
    {
      id: "grundpflege",
      icon: "HandHeart",
      title: "العناية الأساسية",
      short: "العناية بالجسم والمساعدة على الحركة وفي شؤون الحياة اليومية، بهدوء وكرامة.",
      description:
        "في العناية الأساسية نساندكم بلطف في كل الأمور اليومية المتعلقة بالنظافة الشخصية والحركة. نمنحكم وقتنا ونحرص دائماً على كرامتكم وحقكم في تقرير شؤونكم.",
      points: [
        "العناية بالجسم (الغسل، الاستحمام، الدُّش)",
        "المساعدة على الحركة وتغيير الوضعية",
        "العناية في حالات سلس البول",
        "المساعدة في تناول الطعام",
        "المساعدة في ارتداء الملابس وخلعها",
      ],
    },
    {
      id: "behandlungspflege",
      icon: "Stethoscope",
      title: "الرعاية التمريضية الطبية",
      short: "رعاية طبية بناءً على وصفة الطبيب، بموثوقية واحتراف.",
      description:
        "تشمل الرعاية التمريضية الطبية جميع الإجراءات الضرورية طبياً وتُقدَّم دائماً بناءً على وصفة الطبيب. يعمل طاقمنا المعتمد بتعاون وثيق مع أطبائكم.",
      points: [
        "إعطاء الأدوية وتحضيرها",
        "الحقن",
        "ارتداء الجوارب الضاغطة وخلعها",
        "العناية الحديثة بالجروح",
        "مراقبة سكر الدم وضغط الدم",
      ],
      note: "تُقدَّم الرعاية التمريضية الطبية دائماً بناءً على وصفة الطبيب.",
    },
    {
      id: "hauswirtschaft",
      icon: "Home",
      title: "المساعدة المنزلية",
      short: "نتولى شؤون المنزل لتشعروا فيه بالراحة التامة.",
      description:
        "المنزل المرتّب يسهم كثيراً في الشعور بالراحة. نساعدكم في إدارة شؤون المنزل لتشعروا بين جدرانكم بالطمأنينة والأمان.",
      points: [
        "التسوق وقضاء الحاجات",
        "تحضير الوجبات",
        "غسل الملابس",
        "تنظيف المنزل",
      ],
    },
    {
      id: "betreuung",
      icon: "Users",
      title: "خدمات مرافقة إضافية",
      short: "وقت مشترك وأحاديث وأنشطة تحفيزية لمزيد من بهجة الحياة.",
      description:
        "إلى جانب الرعاية، تهمّنا كثيراً اللمسة الإنسانية. نخفّف العبء عن الأقارب القائمين بالرعاية ونمنحكم وقتاً للحظات جميلة مشتركة.",
      points: [
        "تخفيف العبء عن الأقارب القائمين بالرعاية",
        "تمارين التوجّه والإدراك",
        "الحديث والمؤانسة",
        "العمل على السيرة الحياتية",
      ],
    },
    {
      id: "anleitung",
      icon: "GraduationCap",
      title: "إرشاد الأقارب القائمين بالرعاية",
      short: "نساعد أقاربكم على مساعدتكم.",
      description:
        "الأقارب القائمون بالرعاية يقومون بعمل عظيم. نقدّم لكم إرشادات عملية وثقة في التعامل مع الرعاية، بشكل فردي ومفهوم، في منزلكم.",
      points: [
        "إرشاد عملي للرعاية في المنزل",
        "استشارة بشأن الوسائل المساعدة",
        "نصائح لحياة يومية تراعي احتياجات الرعاية",
        "الثقة في التعامل مع الرعاية",
      ],
    },
    {
      id: "erreichbarkeit",
      icon: "Clock",
      title: "التواصل على مدار الساعة",
      short: "متاحون على الهاتف المحمول على مدار الساعة لتشعروا بالأمان.",
      description:
        "في الحالات الطارئة نحن معكم في أي وقت من الليل أو النهار. تصلون إلينا على رقم الطوارئ المحمول على مدار الساعة.",
      points: [
        "رقم الطوارئ المحمول: 0177 / 7202956",
        "رقم بديل: 0157 / 36442746",
        "مساعدة سريعة عند الضرورة",
        "أمان لكم ولذويكم",
      ],
    },
  ],

  servicesPage: {
    eyebrow: "خدماتنا",
    title: "رعاية شاملة، مصمّمة لكم",
    subtitle:
      "نقدّم لكم مجموعة واسعة من خدمات الرعاية والمساعدة المنزلية نكيّفها بدقة مع وضعكم.",
    shortLongTitle: "الرعاية قصيرة الأمد والدائمة",
    shortLongText:
      "سواء مؤقتاً بعد الخروج من المستشفى أو بشكل دائم: نكيّف رعايتنا بمرونة مع ظروف حياتكم. هكذا تحصلون بالضبط على الدعم الذي تحتاجونه الآن.",
    adviceTitle: "استشارة بشأن درجات الرعاية وصندوق تأمين الرعاية",
    adviceText:
      "نظام الرعاية معقّد. نشرح لكم بوضوح الخدمات التي تستحقونها وندعمكم خطوة بخطوة في تقديم الطلب إلى صندوق تأمين الرعاية.",
    ctaTitle: "اطلبوا استشارة مجانية",
    ctaLead: "يسعدنا تقديم المشورة لكم شخصياً ودون التزام، في مكتبنا أو في منزلكم.",
  },

  about: {
    eyebrow: "من نحن",
    title: "أناس يمنحونكم وقتهم",
    subtitle:
      "تعرّفوا على فريقنا وفلسفتنا. ما يميّزنا هو الوقت والاحترام والعناية والإنسانية الحقيقية.",
    introTitle: "راحتكم هي محور اهتمامنا",
    intro: [
      "نحن فريق Nieder-Eschbacher Pflegedienst في فرانكفورت أم ماين. نعمل يوماً بعد يوم من أجل من يمنحوننا ثقتهم. الرعاية بالنسبة لنا أكثر بكثير من مجرد مهمة. إنها مسألة قلب.",
      "طاقمنا الودود المعتمد يمنحكم وقته عن قصد. فالرعاية الجيدة تحتاج إلى هدوء واهتمام وأذن صاغية، بلا عجلة.",
      "نرعاكم حيث تشعرون بأكبر قدر من الراحة: في منزلكم وبيئتكم المألوفة. هكذا تحافظون على استقلاليتكم وخصوصيتكم.",
    ],
    teamImgAlt: "ممرّضة تمسك بحنان يدَي سيدة مسنّة على كرسي متحرك (صورة تعبيرية)",
    valuesTitle: "القيم التي تقودنا",
    valuesLead: "الاحترام والعناية والتعامل المسؤول هي مبادئنا الأساسية.",
    pillars: [
      { icon: "Clock", title: "الوقت", text: "نعمل بلا عجلة ونمنحكم اهتماماً حقيقياً." },
      { icon: "Heart", title: "العناية", text: "كل إنسان فريد. وكذلك رعايتنا." },
      { icon: "Home", title: "المنزل", text: "رعاية في البيئة المألوفة التي تمنح الأمان." },
    ],
    ctaTitle: "تعرّفوا علينا",
    ctaLead: "يسعدنا لقاؤكم في حديث شخصي.",
  },

  newsPage: {
    eyebrow: "الأخبار",
    title: "الأخبار وفرص العمل",
    subtitle: "جديد خدمة الرعاية لدينا والوظائف الشاغرة لكل من يرغب في الانضمام إلى فريقنا.",
    newsTitle: "الأخبار",
    newsLead: "معلومات حديثة من خدمة الرعاية لدينا.",
    careerEyebrow: "الوظائف",
    careerTitle: "انضموا إلى فريقنا",
    careerLead:
      "تحبون العمل في مجال الرعاية وترغبون في العمل ضمن فريق ودود يمنح الناس وقتاً حقيقياً؟ إذاً ننتظر طلب توظيفكم.",
    applyNow: "قدّم طلبك الآن",
    applySubject: "طلب توظيف: مساعد/ة رعاية",
    tasks: "مهامكم",
    profile: "مؤهلاتكم",
    offer: "ما نقدّمه",
    interested: "هل أثار ذلك اهتمامكم؟ أرسلوا طلبكم إلى",
    orCall: "أو اتصلوا بنا على الرقم",
    questions: "لديكم أسئلة؟ تواصلوا معنا",
  },

  news: [
    {
      id: "willkommen",
      date: "2026-09-21",
      category: "أخبار",
      title: "أهلاً بكم في موقعنا الجديد",
      excerpt:
        "يسعدنا أن نقدّم لكم خدمة الرعاية وخدماتنا من الآن على الإنترنت أيضاً: بشكل مرتّب وواضح ومتاح دائماً.",
      body: "هدفنا أن نجعل كل المعلومات المهمة حول الرعاية المنزلية في متناولكم ومتناول ذويكم بسهولة. لأي سؤال يمكنكم التواصل معنا في أي وقت هاتفياً أو عبر نموذج الاتصال.",
    },
    {
      id: "pflegeberatung",
      date: "2025-10-28",
      category: "استشارة",
      title: "استشارة رعاية مجانية في مكتبنا أو في منزلكم",
      excerpt:
        "لستم متأكدين من درجة الرعاية المناسبة لكم؟ يسعدنا تقديم المشورة لكم شخصياً ودون التزام في كل ما يتعلق بصندوق تأمين الرعاية ودرجات الرعاية.",
      body: "نظام الرعاية في ألمانيا معقّد. نمنحكم وقتنا ونشرح لكم الخيارات بهدوء وندعمكم في تقديم طلبات الخدمات. ما عليكم سوى حجز موعد.",
    },
    {
      id: "team-verstaerkung",
      date: "2025-10-05",
      category: "الفريق",
      title: "نحن ننمو ونبحث عن زملاء جدد",
      excerpt:
        "فريقنا ينمو باستمرار. كونوا جزءاً من فريق ودود يمارس الرعاية بوقت واحترام.",
      body: "نوفّر ظروف عمل عادلة، وتعاملاً يقدّر الجميع، ووقتاً حقيقياً للأشخاص الذين نرعاهم. اطّلعوا على فرص العمل الحالية لدينا.",
    },
  ],

  jobs: [
    {
      id: "pflegehelfer",
      title: "مساعد/ة رعاية",
      type: "دوام جزئي أو كامل",
      location: "فرانكفورت أم ماين، Nieder-Eschbach",
      intro:
        "لتعزيز فريقنا نبحث عن مساعد أو مساعدة رعاية يجسّد قيمنا: الوقت والاحترام والعناية. نرحّب أيضاً بمن يغيّرون مهنتهم ولديهم قلب لهذا العمل.",
      tasks: [
        "المساندة في العناية الأساسية لعملائنا",
        "المساعدة على الحركة وفي شؤون الحياة اليومية",
        "المرافقة واللمسة الإنسانية",
        "التعاون الوثيق ضمن فريق الرعاية",
      ],
      requirements: [
        "حب العمل مع الناس والقدرة على التعاطف",
        "الموثوقية والشعور بالمسؤولية وروح الفريق",
        "خبرة أولى في الرعاية ميزة إضافية (غير إلزامية)",
        "رخصة قيادة فئة B ميزة إضافية",
      ],
      offer: [
        "أجر عادل يُدفع في موعده",
        "فريق ودود يقدّر الجميع",
        "وقت حقيقي للرعاية، بلا عجلة",
        "تدريب عند بدء العمل ودورات تأهيل مستمرة",
      ],
    },
  ],

  contact: {
    eyebrow: "اتصل بنا",
    title: "نحن هنا من أجلكم",
    subtitle:
      "أسئلة حول الرعاية، أو طلب موعد، أو استشارة: تواصلوا معنا دون التزام. يسعدنا سماع منكم.",
    formTitle: "راسلونا",
    formLead: "سنردّ عليكم في أقرب وقت ممكن.",
    name: "الاسم",
    namePlaceholder: "اسمكم",
    email: "البريد الإلكتروني",
    emailPlaceholder: "name@example.de",
    phone: "الهاتف",
    phonePlaceholder: "رقم هاتفكم",
    message: "الرسالة",
    messagePlaceholder: "كيف يمكننا مساعدتكم؟",
    consentBefore: "قرأتُ",
    consentLink: "سياسة الخصوصية",
    consentAfter:
      "وأوافق على معالجة بياناتي (بما فيها أي معلومات صحية قد تتضمنها رسالتي) لغرض الردّ على طلبي. يمكنني سحب هذه الموافقة في أي وقت.",
    submit: "إرسال الرسالة",
    sending: "جارٍ الإرسال…",
    subject: "استفسار عبر الموقع الإلكتروني",
    errName: "يرجى إدخال اسمكم.",
    errEmail: "يرجى إدخال عنوان بريد إلكتروني صحيح.",
    errMessage: "يرجى كتابة رسالة قصيرة لنا.",
    errConsent: "يرجى الموافقة على سياسة الخصوصية.",
    toastCheck: "يرجى مراجعة البيانات المدخلة.",
    toastSuccess: "شكراً لكم! تم إرسال رسالتكم بنجاح.",
    toastError: "حدث خطأ. يرجى الاتصال بنا هاتفياً.",
    successTitle: "شكراً لكم!",
    successText: "تم إرسال رسالتكم. سنتواصل معكم قريباً.",
    sendAnother: "إرسال رسالة أخرى",
    reachTitle: "للتواصل معنا",
    address: "العنوان",
    phoneLabel: "الهاتف",
    fax: "فاكس",
    emergency: "رقم الطوارئ على مدار الساعة",
    alternatively: "أو",
    emailLabel: "البريد الإلكتروني",
    hoursTitle: "ساعات العمل",
    hours: "الاثنين إلى الجمعة: 08:00 إلى 17:00",
    careAndEmergency: "الرعاية والطوارئ:",
    aroundTheClock: "على مدار الساعة",
    mapTitle: "كيف تجدوننا",
    mapIframeTitle: "موقع Nieder-Eschbacher Pflegedienst على خرائط Google",
    mapLoad: "تحميل الخريطة",
    mapNotice:
      "حفاظاً على الخصوصية، لا تُحمَّل خريطة Google Maps إلا بعد موافقتكم. وعندها تُنقل بيانات إلى Google.",
    mapButton: "تحميل الخريطة وعرض الموقع",
    mapAlt: "أو الفتح في خرائط Google",
  },

  reviews: {
    eyebrow: "التقييمات",
    title: "ماذا يقول ذوو المرضى والمرضى",
    emptyLead: "تجربتكم تساعد عائلات أخرى في فرانكفورت على إيجاد خدمة الرعاية المناسبة.",
    countOn: "تقييماً على",
    source: "تقييمات علنية من ملفنا التجاري على Google.",
    asOf: "بتاريخ:",
    all: "كل التقييمات على Google",
    write: "اكتب تقييماً",
    on: "على",
    starsLabel: "من 5 نجوم",
  },

  notFound: {
    title: "الصفحة غير موجودة",
    subtitle: "خطأ 404",
    text: "الصفحة المطلوبة غير موجودة أو تم نقلها.",
    home: "العودة إلى الصفحة الرئيسية",
  },

  imprint: {
    title: "بيانات الناشر",
    subtitle: "معلومات وفقاً للمادة 5 من قانون الخدمات الرقمية الألماني (DDG)",
    company: "معلومات وفقاً للمادة 5 DDG",
    country: "ألمانيا",
    representedBy: "يمثّلها",
    managingDirector: "المديرة العامة",
    contact: "الاتصال",
    phone: "الهاتف",
    fax: "فاكس",
    email: "البريد الإلكتروني",
    register: "القيد في السجل التجاري",
    registerCourt: "محكمة السجل",
    registerNumber: "رقم السجل",
    taxNumber: "الرقم الضريبي",
    licence: "الترخيص وجهة الرقابة",
    licenceText:
      "خدمة رعاية منزلية مرخّصة بموجب عقد تقديم خدمات الرعاية وفقاً للمادة 72 من القانون الاجتماعي، الكتاب الحادي عشر (SGB XI)، مع اتحادات صناديق تأمين الرعاية في ولاية هيسن.",
    authorityText:
      "جهة الرقابة المختصة وفقاً لقانون ولاية هيسن لخدمات الرعاية والمرافقة (HGBP):",
    dispute: "تسوية نزاعات المستهلكين",
    disputeText:
      "لسنا مستعدين ولا ملزمين بالمشاركة في إجراءات تسوية النزاعات أمام هيئة تحكيم للمستهلكين (المادة 36 VSBG).",
    responsible: "المسؤولة عن المحتوى وفقاً للمادة 18 الفقرة 2 من معاهدة الولايات للإعلام (MStV)",
    credit: "التصميم والتنفيذ التقني",
    liabilityContent: "المسؤولية عن المحتوى",
    liabilityContentText:
      "بصفتنا مقدّم خدمة، نتحمّل المسؤولية عن محتوانا الخاص في هذه الصفحات وفقاً للقوانين العامة. غير أننا لسنا ملزمين بمراقبة المعلومات الأجنبية المنقولة أو المخزّنة، أو بالبحث عن ظروف تشير إلى نشاط غير مشروع (المادة 8 من اللائحة (EU) 2022/2065، قانون الخدمات الرقمية). وتبقى الالتزامات بإزالة المعلومات أو حجب استخدامها وفقاً للقوانين العامة سارية. ولا تنشأ المسؤولية في هذا الشأن إلا اعتباراً من لحظة العلم بانتهاك قانوني محدد. وعند علمنا بمثل هذه الانتهاكات سنزيل المحتوى المعني فوراً.",
    liabilityLinks: "المسؤولية عن الروابط",
    liabilityLinksText:
      "يحتوي موقعنا على روابط إلى مواقع خارجية تابعة لأطراف ثالثة لا سلطة لنا على محتواها. لذلك لا يمكننا تحمّل أي ضمان عن هذا المحتوى الأجنبي. المسؤول عن محتوى الصفحات المرتبطة هو دائماً مقدّمها أو مشغّلها. وقد جرى فحص الصفحات المرتبطة وقت إدراج الرابط للتحقق من خلوّها من انتهاكات قانونية محتملة، ولم يُلاحظ أي محتوى غير مشروع في ذلك الوقت. ولا يمكن معقولاً مراقبة محتوى الصفحات المرتبطة باستمرار دون وجود مؤشرات ملموسة على انتهاك. وعند علمنا بانتهاكات قانونية سنزيل مثل هذه الروابط فوراً.",
    copyright: "حقوق التأليف والنشر",
    copyrightText:
      "يخضع المحتوى والأعمال التي أنشأها مشغّل الموقع في هذه الصفحات لقانون حقوق التأليف والنشر الألماني. ويتطلب النسخ والتعديل والتوزيع وأي نوع من الاستخدام خارج حدود قانون حقوق التأليف موافقة خطية من المؤلف أو المنشئ المعني. ويُسمح بتنزيل هذا الموقع ونسخه للاستخدام الخاص غير التجاري فقط. وحيثما لم يكن المحتوى من إنشاء المشغّل، تُحترم حقوق التأليف للأطراف الثالثة، ويُشار إلى محتوى الأطراف الثالثة بوصفه كذلك. وإذا لاحظتم رغم ذلك انتهاكاً لحقوق التأليف فنرجو إبلاغنا. وعند علمنا بانتهاكات سنزيل مثل هذا المحتوى فوراً.",
  },

  privacy: {
    title: "سياسة الخصوصية",
    subtitle: "معلومات حول معالجة بياناتكم الشخصية وفقاً للائحة العامة لحماية البيانات (GDPR)",
    retention: "ستة أشهر",
    lastUpdated: "آخر تحديث: أكتوبر 2026",
    controller: {
      title: "1. المسؤول عن معالجة البيانات",
      lead: "المسؤول عن معالجة البيانات في هذا الموقع بمفهوم اللائحة العامة لحماية البيانات (GDPR) هو:",
      representedBy: "ممثَّلة بالمديرة العامة",
      phone: "الهاتف",
      fax: "فاكس",
      email: "البريد الإلكتروني",
    },
    dpo: {
      title: "مسؤول حماية البيانات",
      lead: "يمكنكم التواصل مع مسؤول حماية البيانات لدينا عبر:",
    },
    general: {
      title: "2. معلومات عامة حول معالجة البيانات",
      p: [
        "نعالج البيانات الشخصية فقط بالقدر اللازم لتشغيل موقع إلكتروني يعمل بشكل سليم ولمعالجة استفساراتكم. الأسس القانونية هي المادة 6 الفقرة 1 (a) من GDPR (الموافقة)، والمادة 6 الفقرة 1 (b) من GDPR (العقد أو الخطوات التمهيدية للتعاقد)، والمادة 6 الفقرة 1 (f) من GDPR (المصلحة المشروعة في تشغيل آمن ومستقر لهذا الموقع).",
        "هذا الموقع **لا يستخدم ملفات تعريف الارتباط (الكوكيز)**، ولا يخزّن معلومات على جهازكم (المادة 25 TDDDG)، ولا يستخدم خدمات تحليل أو تتبّع أو إعلانات. تُحمَّل الخطوط والصور من خادمنا الخاص؛ وعند فتح الصفحات لا تُنقل أي بيانات إلى خدمات خطوط أو صور تابعة لأطراف ثالثة. ولا يُتخذ أي قرار آلي بالكامل بما في ذلك التنميط (المادة 22 GDPR).",
      ],
    },
    hosting: {
      title: "3. الاستضافة وملفات سجل الخادم",
      ownIntro:
        "يُشغَّل هذا الموقع بتكليف منّا من قِبل {operator} على خادم في ألمانيا. مزوّد مركز البيانات والخادم هو {provider}.",
      logs: "عند كل زيارة تُعالَج بيانات الاتصال الضرورية تقنياً: عنوان IP، تاريخ الوصول ووقته، الصفحة المطلوبة، حجم البيانات المنقولة، نوع المتصفح وإصداره، نظام التشغيل، والصفحة التي تمت زيارتها قبل ذلك (المُحيل). لا تُدمج هذه البيانات مع مصادر بيانات أخرى، وتُستخدم حصراً لتقديم الموقع وحمايته وتحليل الأخطاء. الأساس القانوني هو المادة 6 الفقرة 1 (f) من GDPR. تُحفظ ملفات سجل الخادم فقط طالما كان ذلك ضرورياً للتشغيل الآمن، ثم تُحذف أو تُجعل مجهولة الهوية.",
      ownLegal:
        "توجد عقود معالجة بيانات وفقاً للمادة 28 من GDPR مع المشغّل ومع مزوّد مركز البيانات. ولا يحدث نقل إلى دول ثالثة في إطار الاستضافة.",
    },
    form: {
      title: "4. نموذج الاتصال",
      p: [
        "عندما ترسلون إلينا استفساراً عبر نموذج الاتصال، نعالج البيانات التي تدخلونها (الاسم، عنوان البريد الإلكتروني، رقم الهاتف اختيارياً، ورسالتكم) لمعالجة استفساركم والإجابة عن أي أسئلة لاحقة. الأساس القانوني هو المادة 6 الفقرة 1 (b) من GDPR (التمهيد لعلاقة رعاية)، وإذا شاركتمونا معلومات صحية، فموافقتكم الصريحة وفقاً للمادة 9 الفقرة 2 (a) من GDPR التي تمنحونها عبر خانة الاختيار في النموذج.",
        "الحقول الإلزامية هي الاسم وعنوان البريد الإلكتروني والرسالة؛ أما رقم الهاتف فاختياري. بدون الحقول الإلزامية لا يمكننا معالجة استفساركم، ويمكنكم عندها الاتصال بنا هاتفياً في أي وقت. يتم النقل بشكل مشفّر (TLS). يُحفظ استفساركم حصراً على خادم في ألمانيا يعمل بتكليف منا، ولا يُمرَّر إلى أطراف ثالثة. نحذف البيانات في موعد أقصاه {retention} بعد الانتهاء من معالجة استفساركم، ما لم تنشأ علاقة رعاية وما لم تمنع ذلك التزامات قانونية بالحفظ. يمكنكم سحب موافقتكم في أي وقت بأثر مستقبلي، مثلاً عبر بريد إلكتروني إلى {email}.",
      ],
    },
    emailPhone: {
      title: "5. التواصل عبر البريد الإلكتروني أو الهاتف أو واتساب",
      p: [
        "عندما تتواصلون معنا عبر البريد الإلكتروني أو الهاتف، نعالج بياناتكم لمعالجة طلبكم (المادة 6 الفقرة 1 (b) و(f) من GDPR). يرجى ملاحظة أن رسائل البريد الإلكتروني غير المشفّرة قد تكون قابلة للاطلاع من قبل أطراف ثالثة أثناء النقل؛ وللمعلومات الصحية ننصح بالهاتف أو الحديث الشخصي.",
        "تصلنا الرسائل المُرسَلة إلى {email} عبر خدمة تحويل: يتولى التسليم {forwarder}، وصندوق البريد لدى {mailbox}. وتُعالَج في أثناء ذلك عنوان المُرسِل وموضوع الرسالة ومحتواها، وتُنقل البيانات إلى الولايات المتحدة أيضاً. الأساس القانوني هو المادة 6 الفقرة 1 (f) من GDPR. لذا يرجى عدم إرسال بيانات صحية بالبريد الإلكتروني، واستخدام الهاتف أو الحديث الشخصي لهذا الغرض.",
        "يوجد في موقعنا رابط يمكنكم عبره مراسلتنا على واتساب. المزوّد هو WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2، أيرلندا. الرابط مجرّد إحالة: لا يُنشأ الاتصال بواتساب إلا عند نقركم عليه، وعندها يُنقل رقم هاتفكم المحمول ومحتوى رسالتكم إلى واتساب. الأساس القانوني هو المادة 6 الفقرة 1 (b) من GDPR. ويعالج واتساب البيانات خارج الاتحاد الأوروبي أيضاً؛ وMeta معتمدة بموجب إطار خصوصية البيانات بين الاتحاد الأوروبي والولايات المتحدة. يرجى عدم إرسال بيانات صحية عبر واتساب، واستخدام الهاتف في الحالات الطارئة.",
      ],
    },
    applications: {
      title: "6. طلبات التوظيف",
      p: [
        "تُرسل طلبات التوظيف على وظائفنا الشاغرة إلينا عبر البريد الإلكتروني. نعالج مستندات طلبكم حصراً لإجراء عملية التوظيف (المادة 6 الفقرة 1 (b) من GDPR، والمادة 26 BDSG). بعد انتهاء العملية تُحذف المستندات في موعد أقصاه ستة أشهر، ما لم توافقوا على حفظ أطول أو تنشأ علاقة عمل.",
      ],
    },
    maps: {
      title: "7. خرائط Google (حل النقرتين)",
      p: [
        "في صفحة الاتصال نعرض خريطة من خدمة Google Maps. المزوّد هو Google Ireland Limited, Gordon House, Barrow Street, Dublin 4، أيرلندا. لا تُحمَّل الخريطة **إلا بعد نقركم الصريح** على «تحميل الخريطة»؛ وقبل ذلك لا تُنقل أي بيانات إلى Google. وبالنقر توافقون (المادة 6 الفقرة 1 (a) من GDPR) على أن تعالج Google عنوان IP الخاص بكم وبيانات الاستخدام وأن تنقلها عند الاقتضاء إلى خوادم Google LLC في الولايات المتحدة؛ وقد تضع Google عندها ملفات تعريف ارتباط على جهازكم. Google معتمدة بموجب إطار خصوصية البيانات بين الاتحاد الأوروبي والولايات المتحدة وتستخدم إضافةً إلى ذلك البنود التعاقدية النموذجية. تسري موافقتكم على عرض الصفحة الحالي فقط. مزيد من المعلومات: [policies.google.com/privacy](https://policies.google.com/privacy).",
      ],
    },
    rights: {
      title: "8. حقوقكم",
      lead: "لكم تجاهنا الحقوق التالية فيما يتعلق ببياناتكم الشخصية:",
      items: [
        "الحق في الاطلاع (المادة 15 GDPR)",
        "الحق في التصحيح (المادة 16 GDPR)",
        "الحق في الحذف (المادة 17 GDPR)",
        "الحق في تقييد المعالجة (المادة 18 GDPR)",
        "الحق في نقل البيانات (المادة 20 GDPR)",
        "الحق في الاعتراض على المعالجة القائمة على المادة 6 الفقرة 1 (f) من GDPR (المادة 21 GDPR)",
        "الحق في سحب الموافقة الممنوحة بأثر مستقبلي (المادة 7 الفقرة 3 GDPR)",
      ],
      how: "لممارسة حقوقكم تكفي رسالة غير رسمية إلى {email} أو بالبريد إلى العنوان المذكور أعلاه.",
    },
    authority: {
      title: "9. الحق في تقديم شكوى إلى جهة الرقابة",
      lead: "يحق لكم تقديم شكوى إلى جهة رقابية لحماية البيانات (المادة 77 GDPR). الجهة المختصة بنا هي:",
      name: "مفوّض ولاية هيسن لحماية البيانات وحرية المعلومات",
      address: "Gustav-Stresemann-Ring 1, 65189 Wiesbaden، ألمانيا",
      url: "https://datenschutz.hessen.de",
      urlLabel: "datenschutz.hessen.de",
    },
    security: {
      title: "10. أمن البيانات",
      p: [
        "يُقدَّم هذا الموقع حصراً عبر اتصال HTTPS مشفّر (TLS). نتخذ تدابير تقنية وتنظيمية لحماية بياناتكم من الفقدان والتلاعب والوصول غير المصرح به، ونواصل تحديثها وفق أحدث ما وصلت إليه التقنية.",
      ],
    },
    changes: {
      title: "11. التعديلات على سياسة الخصوصية هذه",
      p: [
        "نحدّث سياسة الخصوصية هذه عند تغيّر الوضع القانوني أو موقعنا الإلكتروني. والنسخة السارية هي المنشورة هنا.",
      ],
    },
  },
};

export default ar;
